import { render, staticRenderFns } from "./firstBatch.vue?vue&type=template&id=9fa18770&scoped=true&"
import script from "./firstBatch.vue?vue&type=script&lang=js&"
export * from "./firstBatch.vue?vue&type=script&lang=js&"
import style0 from "./firstBatch.vue?vue&type=style&index=0&id=9fa18770&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa18770",
  null
  
)

export default component.exports